import React, { ReactNode, VFC, useRef, useEffect } from 'react'
import Heading from './Heading'

type Props = {
  children: ReactNode
}

const Page: VFC<Props> = (props) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    ref.current?.scrollIntoView()
  }, [])

  return (
    <div className="sm:pt-[6px]" ref={ref}>
      <Heading />
      {props.children}
    </div>
  )
}

export default Page
